import { render } from "./iconCintaAzulAncha.vue?vue&type=template&id=72b21765&scoped=true"
import script from "./iconCintaAzulAncha.vue?vue&type=script&lang=js"
export * from "./iconCintaAzulAncha.vue?vue&type=script&lang=js"

import "./iconCintaAzulAncha.vue?vue&type=style&index=0&id=72b21765&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72b21765"

export default script